import React, { useEffect, useState } from "react";

import "./ContactPage.css";
import PhoneIcon from "@mui/icons-material/Phone";
import SmartphoneIcon from "@mui/icons-material/Smartphone";
import EmailIcon from "@mui/icons-material/Email";
import PlaceIcon from "@mui/icons-material/Place";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import backgroundImage from "url:../../public/contact.png";

function ContactUs() {
  const [isVisible, setIsVisible] = useState(false);
  const [copiedText, setCopiedText] = useState("");
  const googleMapsUrl = `https://maps.app.goo.gl/PG8WpkeggUaKpp8Q7`;

  useEffect(() => {
    // Set the background image when the component mounts
    document.body.style.backgroundImage = `url(${backgroundImage})`;
    document.body.style.backgroundSize = "cover"; // Cover the entire page
    document.body.style.backgroundRepeat = "no-repeat"; // Do not repeat the image
    document.body.style.backgroundAttachment = "fixed"; // Fixed background

    setTimeout(() => setIsVisible(true), 100);

    // Optional: Reset the background image when the component unmounts
    return () => {
      document.body.style.backgroundImage = null;
      document.body.style.backgroundSize = null;
      document.body.style.backgroundRepeat = null;
      document.body.style.backgroundAttachment = null;
    };
  }, []);

  const handleCopy = (text, type) => {
    navigator.clipboard.writeText(text);
    setCopiedText(type);
    setTimeout(() => setCopiedText(""), 2000);
  };

  const contactItems = [
    {
      icon: PhoneIcon,
      type: "phone",
      label: "Office",
      value: "+961 9 547 611",
      href: "tel:+9619547611",
      copyText: "+9619547611",
    },
    {
      icon: SmartphoneIcon,
      type: "mobile",
      label: "Mobile",
      value: "+961 3 302 118",
      href: "tel:+9613302118",
      copyText: "+9613302118",
    },
    {
      icon: SmartphoneIcon,
      type: "mobile2",
      label: "Mobile",
      value: "+961 71 996 447",
      href: "tel:+96171996447",
      copyText: "+96171996447",
    },
    {
      icon: EmailIcon,
      type: "email",
      label: "Email",
      value: "contact@mattafinancialservices.com",
      href: "mailto:contact@mattafinancialservices.com",
      copyText: "contact@mattafinancialservices.com",
    },
    {
      icon: PlaceIcon,
      type: "location",
      label: "Address",
      value: "Centre Laura, Bloc B, 3rd Floor, Voix 13, Byblos, Lebanon",
      href: googleMapsUrl,
      external: true,
    },
  ];

  return (
    <div className={`contact-page-container ${isVisible ? "visible" : ""}`}>
      <div className="contact-header">
        <h1 className="contact-title">Get In Touch</h1>
        <p className="contact-subtitle">
          We're here to help and answer any question you might have
        </p>
      </div>

      <div className="contact-content">
        <div className="contact-info">
          {contactItems.map((item, index) => (
            <div
              key={index}
              className="contact-item"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="icon-wrapper">
                <item.icon className="contact-icon" />
              </div>
              <div className="contact-details">
                <span className="contact-label">{item.label}</span>
                <a
                  href={item.href}
                  target={item.external ? "_blank" : undefined}
                  rel={item.external ? "noopener noreferrer" : undefined}
                  className="contact-value"
                >
                  {item.value}
                </a>
              </div>
              {item.copyText && (
                <button
                  className="copy-btn"
                  onClick={() => handleCopy(item.copyText, item.type)}
                  title="Copy to clipboard"
                >
                  {copiedText === item.type ? "✓" : "📋"}
                </button>
              )}
            </div>
          ))}

          <div
            className="contact-item business-hours"
            style={{ animationDelay: "0.5s" }}
          >
            <div className="icon-wrapper">
              <AccessTimeIcon className="contact-icon" />
            </div>
            <div className="contact-details">
              <span className="contact-label">Business Hours</span>
              <div className="hours-list">
                <div className="hours-item">
                  <span>Monday - Friday</span>
                  <span className="hours-time">8:00 AM - 5:00 PM</span>
                </div>
                <div className="hours-item">
                  <span>Saturday</span>
                  <span className="hours-time">9:00 AM - 1:00 PM</span>
                </div>
                <div className="hours-item">
                  <span>Sunday</span>
                  <span className="hours-time">Closed</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="map-container">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2988.98747163947!2d35.653062999999996!3d34.1223197!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x151f5da72a6574d3%3A0x5db0c5569ec44629!2sMATTA%20Financial%20Services!5e1!3m2!1sen!2slb!4v1770058750566!5m2!1sen!2slb"
            width="100%"
            height="100%"
            style={{ border: 0, borderRadius: "15px" }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Office Location"
          ></iframe>
        </div>
      </div>

      {copiedText && (
        <div className="copy-notification">Copied to clipboard! ✓</div>
      )}
    </div>
  );
}

export default ContactUs;
